module.exports = __webpack_public_path__ + "static/media/systems.8568f5aa.png";